<template>
  <div class="antialiased">
    <Sidebar/>
    <div class="page">
      <Header/>
      <div class="content">
        <div class="container">
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">Tambah Target Salesman</h2>
              </div>
            </div>
          </div>
          <div class="box">
            <div class="card">
              <div class="card-body">
                <div class="row">

                  <div class="form-group col-1">
                    <label class="form-label" for="bulan">Bulan</label>
                    <input type="number" min="1" max="12" id="bulan" class="form-control" v-model="target.bulan">
                  </div>

                  <div class="form-group col-2">
                    <label class="form-label" for="tahun">Tahun</label>
                    <input type="number" id="tahun" :min="1900" class="form-control" v-model="target.tahun">
                  </div>

                  <div class="form-group col-3">
                    <label class="form-label" for="id_tim">Tim</label>
                    <selectize id="id_tim" v-model="target.id_tim" data-placeholder="Pilih Tim" :disabled="loading" required>
                      <option :value="d.id" v-for="(d, i) in tim" :key="i"> {{d.nama_tim}}</option>
                    </selectize>
                  </div>

                  <div class="form-group col-3">
                    <label class="form-label" for="id_brand">Brand</label>
                    <selectize id="id_brand" v-model="target.id_brand" data-placeholder="Pilih Brand" :disabled="loading" required>
                      <option :value="d.id" v-for="(d, i) in brand" :key="i"> {{d.nama_brand}} </option>
                    </selectize>
                  </div>

                  <div class="form-group col-3">
                    <label class="form-label" for="id_supervisor">Supervisor</label>
                    <selectize id="id_supervisor" v-model="target.id_supervisor" data-placeholder="Pilih Supervisor" :disabled="loading" required>
                      <option :value="d.id" v-for="(d, i) in supervisor" :key="i"> {{d.nama_sales_supervisor}} </option>
                    </selectize>
                  </div>

                  <div class="form-group col-3">
                    <label class="form-label" for="id_principal">Principal</label>
                    <selectize id="id_principal" v-model="target.id_principal" data-placeholder="Pilih Principal" :disabled="loading" required>
                      <option :value="d.id" v-for="(d, i) in principal" :key="i"> {{d.nama_principal}} </option>
                    </selectize>
                  </div>

                  <div class="form-group col-2">
                    <label class="form-label" for="target_carton">Target Carton</label>
                    <input type="number" id="target_carton" class="form-control" v-model="target.target_carton">
                  </div>
                  <div class="form-group col-2">
                    <label class="form-label" for="target_oa">Target OA</label>
                    <input type="number" id="target_oa" class="form-control" v-model="target.target_oa">
                  </div>
                  
                  <div class="form-group col-1">
                    <label class="form-label" style="color: white">Proses</label>
                    <button
                        class="btn btn-primary"
                        @click="submit"
                        :disabled="loading"
                        >Simpan</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/assets/js/helper";
import {mapActions, mapMutations, mapState} from "vuex";
export default {
  name: "form.vue",
  mixins: [helper],
  data() {
    return {
      tim: [],
      brand: [],
      supervisor: [],
      principal: [],
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('target_salesman', {
      target: state => state.target
    })
  },
  methods: {
    ...mapActions('tim', ['getListTim']),
    ...mapActions('brand', ['getListBrand']),
    ...mapActions('salesman', ['getListSalesmanSpv']),
    ...mapActions('principal', ['getListPrincipal']),
    ...mapActions('target_salesman', ['submitTargetSalesman']),
    ...mapMutations('target_salesman', ['CLEAR_FORM']),
    submit() {
      this.submitTargetSalesman().then((res) => {
        this.$router.push({name: 'Target Salesman'})
      })
    }
  },
  created() {
    this.CLEAR_FORM()
    this.getListTim({}).then((res) => {
      this.tim = res
    })
    this.getListBrand({}).then((res) => {
      this.brand = res
    })
    this.getListSalesmanSpv({}).then((res) => {
      this.supervisor = res
    })
    this.getListPrincipal({}).then((res) => {
      this.principal = res
    })
  }
}
</script>

<style scoped>

</style>
